// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.notification-menu.card[data-v-62e2e44f],
.notification-content[data-v-62e2e44f] {
  border-radius: 0;
  background-color: #fbfbfb;
  height: 400px !important;
  position: relative;
  max-width: 380px;
  overflow: hidden;
  box-shadow: none;
}
.notification-menu.show-notification[data-v-62e2e44f] {
  padding-bottom: 15px;
}
/*removed the radius of card*/
.notification-menu[data-v-62e2e44f] .v-list {
  padding: 0px;
  background-color: transparent;
}
/*Change bg color notification list*/
.notification-menu[data-v-62e2e44f] .v-list .v-list__tile__content {
  width: 100%;
}
.notification-menu[data-v-62e2e44f] .v-list__tile__action {
  min-width: auto;
}
.notification-menu[data-v-62e2e44f] .v-list__tile__action-text {
  position: absolute;
  bottom: 8px;
  right: 5px;
}
.notification-menu[data-v-62e2e44f] .v-list > div {
  background-color: #e6e6e6;
  margin-bottom: 10px;
}
/*Add bg color in notification list item*/
.notification-menu[data-v-62e2e44f] .v-list > div:last-child {
  margin-bottom: 0px;
}
.notification-menu[data-v-62e2e44f] .v-list .v-list__tile {
  padding: 0px 10px;
}
.notification-menu[data-v-62e2e44f] .v-list .v-list__tile__avatar {
  min-width: 42px;
  max-width: 42px;
}
.badge[data-v-62e2e44f] .v-badge__badge {
  top: 0;
  right: 0;
}
/*to set bedge icon position*/
.n-arrow[data-v-62e2e44f] {
  transition: all 0.3s linear;
  border-color: transparent;
  border-bottom-color: #fff;
  border-style: dashed dashed solid;
  border-width: 0 8.5px 8.5px;
  position: absolute;
  left: 13px;
  top: 50px;
  z-index: -1;
  opacity: 0;
  visibility: hidden;
}
.v-menu__activator.v-menu__activator--active .n-arrow[data-v-62e2e44f] {
  top: 37px;
  z-index: 1;
  opacity: 1;
  visibility: visible;
}
.notification-menu[data-v-62e2e44f] .vb-dragger {
  right: 10px;
}
.notification-bell[data-v-62e2e44f] .v-badge--overlap .v-badge__badge {
  top: -6px;
  right: -8px;
}
.notification-menu[data-v-62e2e44f] .v-list__tile {
  min-height: 92px;
  height: auto;
}
.notification-menu[data-v-62e2e44f] .v-list__tile__sub-title {
  white-space: normal;
}
.notification-menu .notification-anchor[data-v-62e2e44f],
.notification-menu[data-v-62e2e44f] .v-tooltip {
  display: inline-block;
  width: 100%;
}
.notification-menu .v-list > .unread-notification[data-v-62e2e44f] {
  background-color: #fff;
}
.clearall-btn[data-v-62e2e44f] {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 1;
}
.notification-menu.show-notification .vb-content[data-v-62e2e44f] {
  height: 92% !important;
  max-height: 350px;
  min-height: 350px;
}
.notification-menu .notification-msg[data-v-62e2e44f] {
  display: flex;
  height: 367px;
}
.notification-msg span[data-v-62e2e44f] {
  margin: auto;
}
.mt-4.show-notification[data-v-62e2e44f] {
  margin-top: 35px !important;
}
.caption[data-v-62e2e44f] time {
  padding-left: 5px;
  font-size: 13px;
  position: relative;
  top: 2px;
  font-family: 'Noto Sans', Avenir, Helvetica, Arial, sans-serif !important;
}
.v-toolbar__content .v-btn--icon[data-v-62e2e44f] {
  margin: 3px !important;
}
.notification-box[data-v-62e2e44f] {
  position: fixed;
  top: 54px !important;
}
.notification-menu.v-card[data-v-62e2e44f] {
  background-color: #eee;
}
.return-visit[data-v-62e2e44f] {
  display: inline-block;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  background-color: #e4e4e4;
}
.return-visit img[data-v-62e2e44f] {
  width: 20px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
